export const mainItem = [
    { id: 1, title: 'MEN' },
    { id: 2, title: 'WOMEN' },
    { id: 3, title: 'KIDS' },
    { id: 4, title: 'ACCESSORIES' },
    { id: 5, title: 'BLOG' },
]

export const Men = [
    { id: 1, type: 'heading', title: 'New Arrivals', cat: '' },
    { id: 2, type: 'heading', title: 'Shop by Occasion', cat: '' },
    { id: 30, type: '', title: '', cat: '' },
    { id: 31, type: '', title: '', cat: '' },
    { id: 32, type: '', title: '', cat: '' },
    { id: 330, type: '', title: '', cat: '' },
    { id: 3, type: 'heading', title: 'Shope by Product', cat: '' },
    { id: 4, type: '', title: 'Wedding', cat: '', occasion: 'Wedding' },
    { id: 34, type: '', title: '', cat: '' },
    { id: 35, type: '', title: '', cat: '' },
    { id: 36, type: '', title: '', cat: '' },
    { id: 37, type: '', title: '', cat: '' },
    { id: 5, type: '', title: 'View All', cat: '' },
    { id: 6, type: '', title: 'Reception', cat: '', occasion: 'Reception' },
    { id: 38, type: '', title: '', cat: '' },
    { id: 39, type: '', title: '', cat: '' },
    { id: 40, type: '', title: '', cat: '' },
    { id: 41, type: '', title: '', cat: '' },
    { id: 7, type: '', title: 'Kurta', cat: 'Kurta' },
    { id: 8, type: '', title: 'Engagement', cat: '', occasion: 'Engagement' },
    { id: 42, type: '', title: '', cat: '' },
    { id: 43, type: '', title: '', cat: '' },
    { id: 44, type: '', title: '', cat: '' },
    { id: 45, type: '', title: '', cat: '' },
    { id: 9, type: '', title: 'Kurta Sets', cat: 'Kurta Sets' },
    { id: 10, type: '', title: 'Sangeet', cat: '', occasion: 'Sangeet' },
    { id: 46, type: '', title: '', cat: '' },
    { id: 47, type: '', title: '', cat: '' },
    { id: 48, type: '', title: '', cat: '' },
    { id: 49, type: '', title: '', cat: '' },
    { id: 11, type: '', title: 'Kurta Jackets Set', cat: 'Kurta Jacket Set' },
    { id: 12, type: '', title: 'Haldi', cat: '', occasion: 'Haldi' },
    { id: 50, type: '', title: '', cat: '' },
    { id: 51, type: '', title: '', cat: '' },
    { id: 52, type: '', title: '', cat: '' },
    { id: 53, type: '', title: '', cat: '' },
    { id: 13, type: '', title: 'Jackets', cat: 'Jackets' },
    { id: 14, type: 'heading', title: 'Celebrity Style', cat: '' },
    { id: 54, type: '', title: '', cat: '' },
    { id: 55, type: '', title: '', cat: '' },
    { id: 56, type: '', title: '', cat: '' },
    { id: 57, type: '', title: '', cat: '' },
    { id: 15, type: '', title: 'Indo-Western', cat: 'Indo-Western' },
    { id: 16, type: '', title: 'Ranveer Singh Collection', cat: 'Ranveer Singh Collection' },
    { id: 59, type: '', title: '', cat: '' },
    { id: 58, type: '', title: '', cat: '' },
    { id: 60, type: '', title: '', cat: '' },
    { id: 61, type: '', title: '', cat: '' },
    { id: 17, type: '', title: 'Sherwani', cat: 'Sherwani' },
    { id: 18, type: 'heading', title: 'Shope By Collection', cat: '' },
    { id: 62, type: '', title: '', cat: '' },
    { id: 63, type: '', title: '', cat: '' },
    { id: 64, type: '', title: '', cat: '' },
    { id: 65, type: '', title: '', cat: '' },
    { id: 19, type: '', title: 'Kurta Dhoti', cat: 'Kurta Dhoti' },
    { id: 20, type: '', title: 'Festive', cat: '', collections: 'Festive' },
    { id: 66, type: '', title: '', cat: '' },
    { id: 67, type: '', title: '', cat: '' },
    { id: 68, type: '', title: '', cat: '' },
    { id: 69, type: '', title: '', cat: '' },
    { id: 21, type: 'heading', title: 'Accessories', cat: '' },
    { id: 22, type: '', title: 'Formal', cat: '', collections: 'Formal' },
    { id: 70, type: '', title: '', cat: '' },
    { id: 71, type: '', title: '', cat: '' },
    { id: 72, type: '', title: '', cat: '' },
    { id: 73, type: '', title: '', cat: '' },
    { id: 23, type: '', title: 'Safas', cat: 'Safa' },
    { id: 24, type: '', title: 'Classic', collections: 'Classic' },
    { id: 74, type: '', title: '', cat: '' },
    { id: 75, type: '', title: '', cat: '' },
    { id: 76, type: '', title: '', cat: '' },
    { id: 77, type: '', title: '', cat: '' },
    { id: 25, type: '', title: 'Malas', cat: 'Mala' },
    { id: 78, type: '', title: '', cat: '' },
    { id: 79, type: '', title: '', cat: '' },
    { id: 80, type: '', title: '', cat: '' },
    { id: 81, type: '', title: '', cat: '' },
    { id: 33, type: '', title: '', cat: '' },
    { id: 27, type: '', title: 'Footware', cat: 'Footware' },
    { id: 82, type: '', title: '', cat: '' },
    { id: 83, type: '', title: '', cat: '' },
    { id: 84, type: '', title: '', cat: '' },
    { id: 85, type: '', title: '', cat: '' },
    { id: 86, type: '', title: '', cat: '' },
    { id: 29, type: '', title: 'Bootomware', cat: 'Bootomware' }
]

export const Women = [
    { id: 1, type: 'heading', title: 'Shop by Product', cat: '' },
    { id: 2, type: 'heading', title: 'Shop by Collection', cat: '' },
    { id: 14, type: '', title: '', cat: '' },
    { id: 15, type: '', title: '', cat: '' },
    { id: 16, type: '', title: '', cat: '' },
    { id: 17, type: '', title: '', cat: '' },
    { id: 3, type: '', title: 'View All', category: '' },
    { id: 4, type: '', title: 'Bridal', collections: 'Bridal' },
    { id: 18, type: '', title: '', cat: '' },
    { id: 19, type: '', title: '', cat: '' },
    { id: 20, type: '', title: '', cat: '' },
    { id: 21, type: '', title: '', cat: '' },
    { id: 5, type: '', title: 'Lehenga', category: 'Lehenga' },
    { id: 6, type: '', title: 'Casual', collections: 'Casual' },
    { id: 22, type: '', title: '', cat: '' },
    { id: 23, type: '', title: '', cat: '' },
    { id: 24, type: '', title: '', cat: '' },
    { id: 25, type: '', title: '', cat: '' },
    { id: 7, type: '', title: 'Gown', category: 'Gown' },
    { id: 8, type: '', title: 'Festive', collections: 'Festive' },
    { id: 26, type: '', title: '', cat: '' },
    { id: 27, type: '', title: '', cat: '' },
    { id: 28, type: '', title: '', cat: '' },
    { id: 29, type: '', title: '', cat: '' },
    { id: 9, type: '', title: 'Saree', category: 'Saree' },
    { id: 10, type: '', title: '', cat: '' },
    { id: 30, type: '', title: '', cat: '' },
    { id: 31, type: '', title: '', cat: '' },
    { id: 32, type: '', title: '', cat: '' },
    { id: 33, type: '', title: '', cat: '' },
    { id: 11, type: '', title: 'Stitched Suits', category: 'Stitched Suits' },
    { id: 12, type: '', title: '', cat: '' },
    { id: 34, type: '', title: '', cat: '' },
    { id: 35, type: '', title: '', cat: '' },
    { id: 36, type: '', title: '', cat: '' },
    { id: 37, type: '', title: '', cat: '' },
    { id: 13, type: '', title: 'Kurti / Suit', category: 'Kurti / Suit' }
]

export const Kids = [
    { id: 1, title: 'Shope by Product' },
    { id: 7, title: '' },
    { id: 8, title: '' },
    { id: 9, title: '' },
    { id: 10, title: '' },
    { id: 11, title: '' },
    { id: 2, title: 'View All' },
    { id: 12, title: '' },
    { id: 13, title: '' },
    { id: 14, title: '' },
    { id: 15, title: '' },
    { id: 16, title: '' },
    { id: 3, title: 'Kurta' },
    { id: 17, title: '' },
    { id: 18, title: '' },
    { id: 19, title: '' },
    { id: 20, title: '' },
    { id: 21, title: '' },
    { id: 4, title: 'Kurta Jacket' },
    { id: 220, title: '' },
    { id: 23, title: '' },
    { id: 24, title: '' },
    { id: 25, title: '' },
    { id: 26, title: '' },
    { id: 5, title: 'Indo-Western' },
    { id: 22, title: '' },
    { id: 27, title: '' },
    { id: 28, title: '' },
    { id: 29, title: '' },
    { id: 30, title: '' },
    { id: 6, title: 'Juti' },
]

export const Accessories = [
    { id: 1, title: 'Shope by Producct' },
    { id: 12, title: '' },
    { id: 13, title: '' },
    { id: 14, title: '' },
    { id: 15, title: '' },
    { id: 11, title: '' },
    { id: 2, title: '.' },
    { id: 16, title: '' },
    { id: 17, title: '' },
    { id: 18, title: '' },
    { id: 19, title: '' },
    { id: 20, title: '' },
    { id: 3, title: 'Juti' },
    { id: 21, title: '' },
    { id: 22, title: '' },
    { id: 23, title: '' },
    { id: 24, title: '' },
    { id: 25, title: '' },
    { id: 4, title: 'Brooch' },
    { id: 26, title: '' },
    { id: 27, title: '' },
    { id: 28, title: '' },
    { id: 29, title: '' },
    { id: 30, title: '' },
    { id: 5, title: 'Pocket Square' },
    { id: 310, title: '' },
    { id: 32, title: '' },
    { id: 33, title: '' },
    { id: 34, title: '' },
    { id: 35, title: '' },
    { id: 6, title: 'Safa' },
    { id: 37, title: '' },
    { id: 38, title: '' },
    { id: 39, title: '' },
    { id: 40, title: '' },
    { id: 41, title: '' },
    { id: 7, title: 'Mala' },
    { id: 46, title: '' },
    { id: 42, title: '' },
    { id: 43, title: '' },
    { id: 44, title: '' },
    { id: 45, title: '' },
    { id: 8, title: 'Bandanna' },
    { id: 47, title: '' },
    { id: 48, title: '' },
    { id: 49, title: '' },
    { id: 50, title: '' },
    { id: 51, title: '' },
    { id: 9, title: 'Sherwani Inner Kurta' },
    { id: 31, title: '' },
    { id: 56, title: '' },
    { id: 53, title: '' },
    { id: 54, title: '' },
    { id: 55, title: '' },
    { id: 10, title: 'Socks' },

]